// bounty, rubicon
import {assign} from '@acng/frontend-bounty/object.js';
import {min} from '@acng/frontend-bounty/std/number.js';
import {FINAL, OWNED, guard} from '@acng/frontend-rubicon';
// enterprise
import {Gallery} from 'acng/core/model/gallery.js';
import {get} from '../service/cache.js';

/**
 * @implements {MovieData}
 */
export class Movie extends Gallery {
  /**
   * @param {MovieData} data
   */
  constructor(data) {
    super(data);

    ASSERT: {
      /**
       * Origin SQL: videos.movies_default
       */
      this.id = data.id;

      /**
       * Pixel width
       */
      this.width = data.width;

      /**
       * Pixel height
       */
      this.height = data.height;

      /**
       * Playtime in seconds
       */
      this.playtime = data.playtime;

      /**
       * File size in bytes
       */
      this.filesize = data.filesize;

      /**
       * FSK requirement for the stream
       */
      this.fsk = data.fsk;

      this.movie_previews = data.movie_previews;

      guard(this, OWNED(data), 'Movie');
      guard(this, FINAL(Movie), 'Movie');
    }

    assign(this, data);
  }

  get hd() {
    return min(this.width, this.height) >= 720;
  }

  /**
   * @deprecated Use `hd`
   */
  isHd() {
    return this.hd;
  }

  /**
   * @deprecated just use the `path` property plz
   * @returns {void}
   */
  goto() {
    location.hash = this.path;
  }

  /**
   * @returns {string}
   */
  get url() {
    return `/sedcard/${this.nickname}/movie/${this.id}`;
  }

  /**
   * @deprecated Use `url`
   * @returns {string}
   */
  get path() {
    return `/sedcard/${this.nickname}/movie/${this.id}`;
  }

  /**
   * @deprecated
   * @param {string} id
   */
  static get(id) {
    return get(parseInt(id));
  }
}
